"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EMPHASIS = void 0;
var _react = _interopRequireDefault(require("react"));
var _button = require("@react-aria/button");
var _FocusRing = require("../../../shared/utility-components/FocusRing");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _button2 = require("./button.tokens");
var _Icon = require("../../media/icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
var EMPHASIS = exports.EMPHASIS = /*#__PURE__*/function (EMPHASIS) {
  EMPHASIS["HIGH"] = "high";
  EMPHASIS["MEDIUM"] = "medium";
  EMPHASIS["MONO"] = "mono";
  EMPHASIS["LOW"] = "low";
  return EMPHASIS;
}({});
var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "BaseButton__StyledButton",
  componentId: "sc-m98l1y-0"
})(["display:flex;justify-content:center;align-items:center;gap:", ";border-radius:", ";box-sizing:border-box;", ";height:", ";min-width:", ";padding:", " ", " ", " ", ";margin:", " 0;outline:none;background-color:", ";border:", ";color:", ";cursor:pointer;white-space:nowrap;& :not(.fixed-colors) > svg{path{fill:", ";}}&:hover{background-color:", ";border:", ";color:", ";& :not(.fixed-colors) > svg{path{fill:", ";}}}&:active{background-color:", ";border:", ";color:", ";}&:disabled{background-color:", ";border:", ";color:", ";& :not(.fixed-colors) > svg{path{fill:", ";}}}"], _globalTokens.globalSpacing['200'], _globalTokens.globalBorder.radius['3'], function (props) {
  return (0, _button2.buttonTokens)(props.theme).font.standard;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).size.height;
}, function (props) {
  return props.iconOnly ? (0, _button2.buttonTokens)(props.theme).size.height : '100px';
}, _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['300'], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['300'], function (props) {
  return props.noMargin ? '0' : '2px';
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.background[props.emphasis].default;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).border[props.emphasis].default;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.font[props.emphasis].default;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.icon[props.emphasis].default;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.background[props.emphasis].hover;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).border[props.emphasis].hover;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.font[props.emphasis].hover;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.icon[props.emphasis].hover;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.background[props.emphasis].pressed;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).border[props.emphasis].pressed;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.font[props.emphasis].pressed;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.background[props.emphasis].disabled;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).border[props.emphasis].disabled;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.font[props.emphasis].disabled;
}, function (props) {
  return (0, _button2.buttonTokens)(props.theme).color.icon[props.emphasis].disabled;
});
var BaseButton = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _props$emphasis = props.emphasis,
    emphasis = _props$emphasis === void 0 ? EMPHASIS.HIGH : _props$emphasis,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    _props$noMargin = props.noMargin,
    noMargin = _props$noMargin === void 0 ? false : _props$noMargin,
    children = props.children,
    _props$useButtonProps = props.useButtonProps,
    useButtonProps = _props$useButtonProps === void 0 ? true : _props$useButtonProps;
  var _ref = (0, _button.useButton)(_objectSpread({
      isDisabled: disabled
    }, props), ref),
    buttonProps = _ref.buttonProps;
  var extraProps = useButtonProps ? buttonProps : props;
  var iconOnly = !!((leftIcon || rightIcon) && !(leftIcon && rightIcon) && !children);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FocusRing.FocusRing, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButton, _objectSpread({}, extraProps, props, {
      ref: ref,
      iconOnly: iconOnly,
      "aria-label": iconOnly ? leftIcon : undefined,
      noMargin: noMargin,
      emphasis: emphasis,
      disabled: disabled,
      children: [leftIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        className: 'left-icon',
        icon: leftIcon
      }), children, rightIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        className: 'right-icon',
        icon: rightIcon
      })]
    }))
  });
});
var _default = exports.default = BaseButton;